// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9beab5eb","272":"998a2241","371":"d1d90b53","594":"3e377060","719":"77246982","786":"cccb1d52"}[chunkId] + ".chunk.css";
};